import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import textContent from "./textContent";
import "../Style/SliFul.css";

const ScrollableText = () => {
    const navigate = useNavigate();
    const textRef = useRef(null);
    const [isScrolledToEnd, setIsScrolledToEnd] = useState(false);
    const [isAgreed, setIsAgreed] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const startYRef = useRef(0);
    const scrollTopRef = useRef(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Resize listener to detect mobile
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleScroll = () => {
        if (textRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = textRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 5) {
                setIsScrolledToEnd(true);
            }
        }
    };

    const handlePointerDown = (e) => {
        setIsDragging(true);
        startYRef.current = e.clientY ?? e.touches?.[0]?.clientY ?? 0;
        scrollTopRef.current = textRef.current.scrollTop;
    };

    const handlePointerMove = (e) => {
        if (!isDragging) return;
        // Manual drag-scrolling only applies to mouse drags. On touch
        // devices we let the browser's native touch-scrolling handle it —
        // previously this ran for touch events too and fought with native
        // momentum scrolling, causing jittery/inverted scrolling on phones.
        if (e.touches) return;
        const currentY = e.clientY;
        const dy = currentY - startYRef.current;
        textRef.current.scrollTop = scrollTopRef.current - dy;
    };

    const handlePointerUp = () => {
        setIsDragging(false);
    };

    const handleSubmitClick = () => {
        if (!isAgreed) {
            alert("Խնդրում ենք ստորագրել փաստաթուղթը");
            return;
        }
        navigate("/page5");
    };

    const scrollToBottom = () => {
        if (textRef.current) {
            textRef.current.scrollTo({
                top: textRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    };

    return (
        <div>
            <div className="scrollable-container">
                <div className="scrollable-card">
                    <h2 className="scrollable-title">
                        ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԻ ՄԱՏՈՒՑՄԱՆ ՀՐԱՊԱՐԱԿԱՅԻՆ ԱՌԱՋԱՐԿ (ՕՖԵՐՏԱ) ԵՎ ԳԱՂՏՆԻՈՒԹՅԱՆ ՔԱՂԱՔԱԿԱՆՈՒԹՅՈՒՆ
                    </h2>
                    <div className="scrollable-content">
                        <div
                            className="scrollable-text"
                            ref={textRef}
                            onScroll={handleScroll}
                            onMouseDown={handlePointerDown}
                            onMouseMove={handlePointerMove}
                            onMouseUp={handlePointerUp}
                            onMouseLeave={handlePointerUp}
                            style={{
                                overflowY: "auto",
                                maxHeight: "300px",
                                cursor: isDragging ? "grabbing" : "grab",
                                touchAction: "pan-y",
                            }}
                            dangerouslySetInnerHTML={{ __html: textContent }}
                        />
                    </div>
                </div>

                {isMobile && !isScrolledToEnd && (
                    <button className="scroll-to-bottom-btn" onClick={scrollToBottom}>Իջնել ներքև</button>
                )}

                <div className="flex items-center_sly my-3">
                    <div className = "input_lable">
                        <input
                            type="checkbox"
                            id="agreement"
                            checked={isAgreed}
                            onChange={(e) => setIsAgreed(e.target.checked)}
                            disabled={!isScrolledToEnd}
                        />
                        <label htmlFor="agreement">
                            Ծանոթացել եմ և համաձայն եմ ուսուցման ընթացքում ծառայությունների տրամադրման պայմաններին
                        </label>
                    </div>

                    <button
                        type="button"
                        onClick={handleSubmitClick}
                        className={`submit-btn ${isAgreed ? "" : "disabled-btn"}`}
                        disabled={!isAgreed}
                    >
                        Հաջորդ էջ
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ScrollableText;
